import { useTheme } from '@mui/material';
import React from 'react';
import { TimetableStatus } from 'types/timetable.types';

function useFnColorByStatus() {
  const theme = useTheme();

  const getBgColorByStatus = React.useCallback(
    (status: TimetableStatus) => {
      if (status === 'A') {
        return theme.palette.error.main;
      }
      if (status === 'D') {
        return theme.palette.success.main;
      }
      return theme.palette.warning.main;
    },
    [theme.palette.error.main, theme.palette.success.main, theme.palette.warning.main],
  );

  return getBgColorByStatus;
}

export default useFnColorByStatus;
